import Stock from './stock';
import Movement from './movement';
import Fault from './fault';
import FaultMovement from './faultMovement';
import FaultClose from './faultClose';
import FaultImage from './faultImage';
import StockMovements from './stockMovements';
import Barcode from './barcode';

export default {
    Stock, Movement, Fault, FaultMovement, FaultClose, FaultImage, StockMovements, Barcode
}


// WEBPACK FOOTER //
// ./src/pages/ERP/Stock/forms/index.js